"use client";
import style from './headerMobile.module.scss';
import HeaderActions from "../partials/header-actions/HeaderActions";
import HeaderMenu from "../partials/header-menu/HeaderMenu";
import { useEffect, useState } from 'react';
import MenuItemDto from '@/projectRoot/api-client/interfaces/models/content/menu/MenuItem.dto';
import { Language } from '@/projectRoot/routes.config';
import NotificationDto from '@/projectRoot/api-client/interfaces/models/content/Notification.dto';
import Notifications from '../notifications/Notifications';

interface Props {
  menu_items: MenuItemDto[];
  multilang_slugs?: Record<Language, string>;
  notifications?: NotificationDto[];
  route_parameter?: {
    list?: string;
    single?: string;
  }
}

const HeaderMobile = ({menu_items, multilang_slugs, route_parameter, notifications}: Props) => {
    const [showSidebar, setShowSidebar] = useState<boolean>(false);
    const [isScrolled, setIsScrolled] = useState<boolean>(false);

    let coloredBg = (multilang_slugs ? (multilang_slugs.sr != process.env.NEXT_PUBLIC_APP_URL && multilang_slugs.en != process.env.NEXT_PUBLIC_APP_URL + '/en') : true);

    const onClickShowSidebar = (show: boolean) => {
        setShowSidebar(show);
    }

    const onScrollSetBackground = () => {
      setIsScrolled(window.scrollY > 80);
    }
  
    useEffect(() => {
      if(typeof window !== 'undefined'){
        window.addEventListener('scroll', onScrollSetBackground);
        return () => {
          window.removeEventListener('scroll', onScrollSetBackground);
        }
      }
    }, []);

  return (
    <section className={`${style.headerMobile} ${coloredBg || isScrolled ? style.scrolled : ''}`}>
      {
        notifications
        ?
        <Notifications 
          classes={coloredBg || isScrolled ? [style.darkNotification] : [style.lightNotification]} 
          notifications={notifications} 
        />
        : <></>
      }
      <HeaderActions hovered={coloredBg || isScrolled} visibleSidebar={showSidebar} onClickShowSidebar={() => onClickShowSidebar(!showSidebar)} />
      <HeaderMenu menu_items={menu_items} classes={[style.sidebarMenu, showSidebar ? style.visible : '', notifications ? style.hasNotifications : '']} multilang_slugs={multilang_slugs} route_parameter={route_parameter} />
    </section>
  )
};

export default HeaderMobile;
